module.exports = __webpack_public_path__ + "assets/img-public.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-public.jpg
// module id = 1663
// module chunks = 7